package tta.destinigo.talktoastro.feature_call_consultation.domain

import tta.destinigo.talktoastro.feature_call_consultation.data.api.CallConsultationApi
import tta.destinigo.talktoastro.feature_call_consultation.data.request.GetCallDurationRequest
import tta.destinigo.talktoastro.feature_call_consultation.data.request.RequestCallDuration
import tta.destinigo.talktoastro.feature_call_consultation.data.response.CallDurationData
import tta.destinigo.talktoastro.feature_call_consultation.data.response.Data
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flow
import tta.destinigo.talktoastro.shared.remote.Resources

class CallConsultationInfoRepo(
    private val api: CallConsultationApi
) {
    fun getCallConsultationInfo(callDurationRequest: RequestCallDuration,isEmergency:Boolean):Flow<Resources<CallDurationData>>{
        return flow {
            emit(Resources.Loading())
            val response = api.getCallDurationInfo(callDurationRequest,isEmergency)
            emit(response)
            emit(Resources.Loading(false))
        }
    }


    fun callPlace(placeCallRequest: GetCallDurationRequest): Flow<Resources<Data>>{
        return flow {
            emit(Resources.Loading())
            val response = api.placeCall(placeCallRequest)
            emit(response)
            emit(Resources.Loading(false))
        }
    }
}